// ============================================
// PRODUCT INFO WIDGETS - COMPLETE JS
// With all 17 brands
// ============================================

(function() {
    'use strict';
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    function init() {
        setupButtons();
        setupModalClosing();
        setupBrandCards();
    }
    
    function setupButtons() {
        var deliveryBtn = document.getElementById('piwDeliveryBtn');
        var sizingBtn = document.getElementById('piwSizingBtn');
        var deliveryModal = document.getElementById('piwDeliveryModal');
        var sizingModal = document.getElementById('piwSizingModal');
        
        if (deliveryBtn && deliveryModal) {
            deliveryBtn.onclick = function() {
                updateDeliveryDates();
                deliveryModal.classList.add('active');
                document.body.style.overflow = 'hidden';
            };
        }
        
        if (sizingBtn && sizingModal) {
            sizingBtn.onclick = function() {
                showBrandSelector();
                sizingModal.classList.add('active');
                document.body.style.overflow = 'hidden';
            };
        }
        
        var floatingBtn = document.getElementById('floatingSizingBtn');
        if (floatingBtn && sizingBtn) {
            floatingBtn.onclick = function() {
                sizingBtn.click();
            };
        }
    }
    
    function setupModalClosing() {
        var modals = document.querySelectorAll('.piw-modal');
        
        modals.forEach(function(modal) {
            var closeBtn = modal.querySelector('.piw-modal-close');
            if (closeBtn) {
                closeBtn.onclick = function() {
                    closeModal(modal);
                };
            }
            
            var overlay = modal.querySelector('.piw-modal-overlay');
            if (overlay) {
                overlay.onclick = function() {
                    closeModal(modal);
                };
            }
        });
        
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                modals.forEach(function(modal) {
                    if (modal.classList.contains('active')) {
                        closeModal(modal);
                        if (modal.id === 'piwSizingModal') {
                            setTimeout(showBrandSelector, 300);
                        }
                    }
                });
            }
        });
    }
    
    function closeModal(modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
    }
    
    function updateDeliveryDates() {
        var now = new Date();
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        
        var orderDateEl = document.getElementById('orderDate');
        if (orderDateEl) {
            orderDateEl.textContent = 'Today (' + now.getDate() + ' ' + months[now.getMonth()] + ')';
        }
        
        var hour = now.getHours();
        var fulfilledDateEl = document.getElementById('fulfilledDate');
        if (fulfilledDateEl) {
            if (hour < 21) {
                fulfilledDateEl.textContent = 'Same day (' + now.getDate() + ' ' + months[now.getMonth()] + ')';
            } else {
                var tomorrow = new Date(now);
                tomorrow.setDate(tomorrow.getDate() + 1);
                fulfilledDateEl.textContent = 'Tomorrow (' + tomorrow.getDate() + ' ' + months[tomorrow.getMonth()] + ')';
            }
        }
    }
    
    function setupBrandCards() {
        var cards = document.querySelectorAll('.piw-brand-card');
        cards.forEach(function(card) {
            card.onclick = function() {
                var brand = this.getAttribute('data-brand');
                if (brand) {
                    loadBrand(brand);
                    showBrandContent();
                }
            };
        });
    }
    
    function showBrandSelector() {
        var selector = document.querySelector('.piw-brand-selector');
        var content = document.getElementById('brandContent');
        if (selector) selector.style.display = 'block';
        if (content) content.style.display = 'none';
    }
    
    function showBrandContent() {
        var selector = document.querySelector('.piw-brand-selector');
        var content = document.getElementById('brandContent');
        if (selector) selector.style.display = 'none';
        if (content) content.style.display = 'block';
    }
    
    function loadBrand(brand) {
        var brandData = {
            apple: {
                title: '🍏 Apple Watch',
                connector: 'Apple proprietary slide-in',
                note: 'No MM width. Must match case size.',
                howToRemove: [
                    'Turn watch face-down',
                    'Hold band-release button',
                    'Slide strap sideways out of slot',
                    'Insert new strap until it clicks'
                ],
                sizes: [
                    { name: '38mm / 40mm / 41mm', size: 'Small connector' },
                    { name: '42mm / 44mm / 45mm / 46mm', size: 'Large connector' },
                    { name: 'Ultra 49mm', size: 'Large/Ultra connector' }
                ]
            },
            samsung: {
                title: '📱 Samsung Galaxy Watch',
                connector: 'Quick-release (20mm / 22mm) except newest proprietary',
                howToFind: [
                    'Look under strap for "20" or "22"',
                    'Samsung product pages list strap width',
                    'All Watch 4/5/6/7 use 20mm'
                ],
                models: [
                    { size: '22mm', devices: 'Gear S3, Watch 46mm, Watch 3 (45mm)' },
                    { size: '20mm', devices: 'Watch 42mm, Watch 3 (41mm), Active series, Watch 4/5/6/7' },
                    { size: 'Proprietary', devices: 'Watch 8, Watch Ultra' }
                ]
            },
            garmin: {
                title: '🧭 Garmin',
                connector: 'Quick-release or QuickFit (tool-free)',
                howToFind: [
                    'Many Garmin straps have width printed inside (e.g., "22")',
                    'Fenix, Epix, Instinct follow consistent size rules'
                ],
                sizes: [
                    { name: 'Fenix 5S / 6S / 7S', size: '20mm QuickFit' },
                    { name: 'Fenix 5 / 6 / 7 / Epix', size: '22mm QuickFit' },
                    { name: 'Fenix 5X / 6X / 7X', size: '26mm QuickFit' },
                    { name: 'Forerunner 45/245/645', size: '20mm' },
                    { name: 'Forerunner 945/955/965', size: '22mm QuickFit' },
                    { name: 'Venu / Vivomove (most models)', size: '20mm' },
                    { name: 'Lily', size: '14mm' },
                    { name: 'Instinct / Instinct 2', size: '22mm' }
                ]
            },
            fitbit: {
                title: '⌚ Fitbit',
                connector: 'Proprietary (not mm-based)',
                note: 'Each Fitbit family has its own unique connector shape. Not interchangeable between families.',
                howToFind: [
                    'Check inside of strap for family name (e.g., "Versa 3", "Charge")',
                    'Bands within same family are usually compatible'
                ],
                families: [
                    { name: 'Charge 3/4', note: 'Compatible with each other' },
                    { name: 'Charge 5/6', note: 'Compatible with each other' },
                    { name: 'Versa 1/2', note: 'Compatible with each other' },
                    { name: 'Versa 3/4 / Sense / Sense 2', note: 'All compatible' },
                    { name: 'Inspire / Inspire 2', note: 'Compatible' },
                    { name: 'Inspire 3', note: 'Specific bands only' },
                    { name: 'Luxe', note: 'Unique slim connector' },
                    { name: 'Ionic / Blaze / Surge / Ace', note: 'Family-specific bands' }
                ]
            },
            huawei: {
                title: '🐉 Huawei',
                connector: 'Quick-release (18mm / 20mm / 22mm)',
                howToFind: [
                    'Check model number in "About Watch" settings',
                    'Smaller case size = smaller strap width'
                ],
                sizes: [
                    { name: 'GT 2/3/4 (46mm), Watch 3/4, Watch D', size: '22mm' },
                    { name: 'GT 2/3 (42mm)', size: '20mm' },
                    { name: 'GT 4/5 (41mm, small)', size: '18mm' },
                    { name: 'Watch Fit / Fit 2', size: 'Proprietary slim band' }
                ]
            },
            xiaomi: {
                title: '🇨🇳 Xiaomi / Redmi',
                connector: 'Quick-release (20mm / 22mm) or proprietary',
                models: [
                    { device: 'Mi Band series', size: 'Proprietary capsule connector' },
                    { device: 'Redmi Watch', size: '20mm or 22mm (check model)' },
                    { device: 'Mi Watch', size: '22mm standard' }
                ]
            },
            amazfit: {
                title: '🧡 Amazfit',
                connector: 'Quick-release (20mm / 22mm)',
                sizes: [
                    { name: 'Bip, Bip S, GTS series, GTR 42mm', size: '20mm' },
                    { name: 'T-Rex series, GTR 47mm, GTR 2/3, Stratos', size: '22mm' }
                ]
            },
            google: {
                title: '🌈 Google Pixel Watch',
                connector: 'Proprietary slide-button connector',
                note: 'Pixel Watch uses unique connector system.',
                sizes: [
                    { name: 'Pixel Watch (41mm)', size: '20mm equivalent' },
                    { name: 'Pixel Watch 2 (41mm)', size: '20mm equivalent' },
                    { name: 'Pixel Watch (45mm)', size: '22mm equivalent' }
                ]
            },
            polar: {
                title: '❄️ Polar',
                connector: 'Quick-release (20mm / 22mm)',
                sizes: [
                    { name: 'Ignite, Pacer, Unite', size: '20mm' },
                    { name: 'Grit X, Vantage M, Vantage V', size: '22mm' }
                ]
            },
            fossil: {
                title: '🕶️ Fossil Smartwatch',
                connector: 'Quick-release (18mm / 22mm)',
                note: 'Size printed inside strap. Includes Hybrid HR and WearOS models.',
                sizes: [
                    { name: 'Most Fossil smartwatches', size: '18mm or 22mm' },
                    { name: 'Gen 5 / Gen 6', size: '22mm' }
                ]
            },
            suunto: {
                title: '🧗 Suunto',
                connector: 'Quick-release (20mm / 22mm / 24mm)',
                sizes: [
                    { name: 'Suunto 3 / Suunto 5', size: '20mm' },
                    { name: 'Vertical, Race, Peak Pro', size: '22mm' },
                    { name: 'Suunto 7 / Suunto 9', size: '24mm' }
                ]
            },
            oppo: {
                title: '🟣 Oppo Watch',
                connector: 'Quick-release (18mm / 20mm / 22mm)',
                sizes: [
                    { name: 'Watch X2 Mini', size: '18mm' },
                    { name: '41mm models', size: '20mm' },
                    { name: '46mm, Watch 3, Watch X', size: '22mm' }
                ]
            },
            honor: {
                title: '🟥 Honor MagicWatch',
                connector: 'Quick-release (20mm / 22mm)',
                sizes: [
                    { name: 'MagicWatch 42mm', size: '20mm' },
                    { name: 'MagicWatch 46mm', size: '22mm' }
                ]
            },
            oneplus: {
                title: '🔴 OnePlus Watch',
                connector: 'Quick-release',
                sizes: [
                    { name: 'All OnePlus Watch models', size: '22mm standard' }
                ]
            },
            coros: {
                title: '🟦 Coros',
                connector: 'Quick-release (20mm / 22mm / 24mm / 26mm)',
                sizes: [
                    { name: 'Apex 42mm, Pace 2', size: '20mm' },
                    { name: 'Apex 2 Pro, Pace 3, Apex 4 (42mm)', size: '22mm' },
                    { name: 'Apex 4 (46mm), Nomad', size: '24mm' },
                    { name: 'Vertix 2 series', size: '26mm' }
                ]
            },
            whoop: {
                title: '🟢 Whoop',
                connector: 'Proprietary Fast Link system',
                note: 'No MM size. Whoop uses unique band system not compatible with standard straps.',
                sizes: [
                    { name: 'Whoop 4.0', size: 'Proprietary Fast Link bands only' },
                    { name: 'Whoop 5.0', size: 'Proprietary Fast Link bands only' }
                ]
            },
            withings: {
                title: '🔵 Withings',
                connector: 'Quick-release (18mm / 20mm)',
                sizes: [
                    { name: 'Steel HR 36mm, ScanWatch 38mm', size: '18mm' },
                    { name: 'Steel HR 40mm, ScanWatch 42mm, Nova', size: '20mm' }
                ]
            }
        };
        
        var data = brandData[brand];
        if (!data) return;
        
        var html = '<div class="brand-section">';
        html += '<button onclick="showBrandSelector()" style="background:#f3f4f6;border:none;padding:0.5rem 1rem;border-radius:8px;cursor:pointer;margin-bottom:1rem;font-size:0.875rem;color:#64748B;font-weight:600">← Back to brands</button>';
        html += '<h3>' + data.title + '</h3>';
        
        html += '<div class="connector-info">';
        html += '<strong>Connector:</strong> ' + data.connector;
        if (data.note) {
            html += '<br><strong>Note:</strong> ' + data.note;
        }
        html += '</div>';
        
        if (data.howToRemove) {
            html += '<h4>How to remove straps:</h4><ol>';
            data.howToRemove.forEach(function(step) {
                html += '<li>' + step + '</li>';
            });
            html += '</ol>';
        }
        
        if (data.howToFind) {
            html += '<h4>How to find size:</h4><ul>';
            data.howToFind.forEach(function(tip) {
                html += '<li>' + tip + '</li>';
            });
            html += '</ul>';
        }
        
        if (data.sizes) {
            html += '<h4>Sizes:</h4><ul>';
            data.sizes.forEach(function(item) {
                html += '<li><strong>' + item.name + ':</strong> ' + item.size + '</li>';
            });
            html += '</ul>';
        }
        
        if (data.families) {
            html += '<h4>Families:</h4><ul>';
            data.families.forEach(function(family) {
                html += '<li><strong>' + family.name + ':</strong> ' + family.note + '</li>';
            });
            html += '</ul>';
        }
        
        if (data.models) {
            html += '<h4>Models:</h4><ul>';
            data.models.forEach(function(model) {
                html += '<li><strong>' + model.device + ':</strong> ' + model.size + '</li>';
            });
            html += '</ul>';
        }
        
        html += '</div>';
        
        document.getElementById('brandContent').innerHTML = html;
    }
    
    window.loadBrand = loadBrand;
    window.showBrandSelector = showBrandSelector;
})();